var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      staticClass: "language-dropdown",
      attrs: {
        "aria-role": "list",
        "mobile-modal": false,
        disabled: !_vm.hasTranslations,
        position: "is-bottom-left",
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "button is-primary is-outlined",
          class: { disabled: !_vm.hasTranslations },
          attrs: { slot: "trigger" },
          slot: "trigger",
        },
        [
          _c(
            "span",
            { staticClass: "icon is-small hideOnCollapse" },
            [_c("font-awesome-icon", { attrs: { icon: ["fas", "globe"] } })],
            1
          ),
          _vm._v(" "),
          _c("span", [
            _vm._v("\n            " + _vm._s(_vm.value) + "\n        "),
          ]),
          _vm._v(" "),
          _vm.hasTranslations
            ? _c(
                "span",
                { staticClass: "icon is-small hideOnCollapse" },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["fas", "angle-down"] },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        { attrs: { "has-link": "", "aria-role": "listitem" } },
        [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.setLibraryLanguage(_vm.defaultLanguage)
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.defaultLanguage.id.toUpperCase()) +
                  "\n            -\n            " +
                  _vm._s(_vm.defaultLanguage.isoLanguageName) +
                  "\n        "
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.languages, function (language) {
        return _c(
          "b-dropdown-item",
          {
            key: language.id,
            attrs: { "has-link": "", "aria-role": "listitem" },
          },
          [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setLibraryLanguage(language)
                  },
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(language.id.toUpperCase()) +
                    " -\n            " +
                    _vm._s(language.isoLanguageName) +
                    "\n        "
                ),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }